import RightBarGroup from './RightBarGroup'
import Select from './Select'
import { useMemo } from 'react'
import {
  ChangeEvent,
  getEnabledFeatures,
  NavType,
} from '@bm-js/atlascloud-shared'
import { useEditorActions, useEditorData } from '../utils/hooks'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const allNavOptions = [
  {
    key: 'nav1',
    label: 'Atlas Cloud Minimalistic',
  },
  {
    key: 'nav2',
    label: 'Atlas Cloud Basic',
  },
  {
    key: 'nav3',
    label: 'Atlas Cloud Enyoi',
  },
]

const NavSelection = () => {
  const { patchConfig } = useEditorActions()
  const { workingConfig, backendResponse } = useEditorData()
  const { website } = backendResponse
  const { tr } = useTr()
  const handleSelect = (e: ChangeEvent) => {
    patchConfig({ navType: e.target.value as NavType })
  }

  const navOptions = useMemo(() => {
    const enabledFeatures = getEnabledFeatures(website.features)
    return allNavOptions.filter((option) => {
      return !!enabledFeatures.find(
        (feature) => feature.key === `${option.key}`
      )
    })
  }, [website.features])

  const shouldRender = useMemo(() => {
    return navOptions.length > 1
  }, [navOptions.length])

  if (!shouldRender) return null

  return (
    <RightBarGroup title='Navigation'>
      <Select value={workingConfig.navType} onChange={handleSelect}>
        <option disabled value=''>
          {tr(TrKey.editorLeftSelectNavPlaceholder)}
        </option>
        {navOptions.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </Select>
    </RightBarGroup>
  )
}

export default NavSelection
